<template>
    <section class="section">
        <div class="container">
            <div class="columns is-centered is-vcentered is-flex-mobile">
                <div class="column is-1">
                    <svg aria-hidden="true" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/animations.sass"
@keyframes fadeIn
    0%
        transform: translateY(-30px)
        opacity: 0
    100%
        opacity: 1
        transform: translateY(0)
.section
    padding: 0
    .columns
        height: 100vh
        .column
            opacity: 0
            animation: 600ms fadeIn
            animation-fill-mode: forwards
            animation-delay: 600ms
            svg
                display: block
                margin: auto
                max-width: 50%
                animation: rotating 1s ease-in-out infinite
                animation-delay: 600ms
                +mobile
                    width: 10%
</style>
